import { createApp } from 'vue';
import { createPinia } from 'pinia';

import auth from '@lib/plugins/auth';
import /* { axiosInstance } from */ '@lib/plugins/axios';
import router from '@/router';

// Main layout component from ef lib
import '@lib/plugins/bootstrap'; // Force load of bootstap
import App from '../../lib/js/layouts/Base.vue';

// Additionals
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/all.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/solid.min.css';
import '@lib/../assets/fontawesome-pro-7.3.0-web/css/brands.min.css';

import '@lib/sass/app-material.scss'

// Create main vue app
const pinia = createPinia();
const app = createApp(App);

// Load main plugins
app.use(pinia);
app.use(router);
app.use(auth);

// Internationalization, see https://kazupon.github.io/vue-i18n/
import { createI18n } from 'vue-i18n';
import { merge } from 'lodash-es';

import lib_locale from '../../lib/js/locale';
import app_locales from '@/locale/index';

const i18n = createI18n({
	locale: 'de',
	fallbackLocale: 'en',
	globalInjection: true,
	messages: globalThis.env.app?.env == 'e2e' ? {} : merge(lib_locale, app_locales),
});

app.use(i18n);

// PrimeVue component library, see https://primefaces.org/primevue/showcase/#/
import PrimeVue from 'primevue/config';
app.use(PrimeVue);

// Load additional components from the ef libraray, eg. the layouts sidebar
// We use the plugin system style to enshure that the components are loaded in the propper order
import EfLib from '@lib/eflib';
app.use(EfLib, {
	plugins: {
		notification: true,
	},
	// The app's own tabs in the lib's pages. Administration > Einstellungen: what HR keeps about
	// the staff in a block of its own after the roles, and the start page in the appearance.
	contributions: {
		slots: {
			'admin.settings': [
				{
					id: 'skills',
					icon: 'fa-book',
					group: 'staff',
					after: 'roles_and_permissions',
					order: 10,
					component: () => import('@/pages/Admin/Settings/UserSkills.vue'),
				},
				{
					id: 'experiences',
					icon: 'fa-star',
					group: 'staff',
					after: 'roles_and_permissions',
					order: 20,
					component: () => import('@/pages/Admin/Settings/Experiences.vue'),
				},
				{
					id: 'contracts',
					icon: 'fa-file-signature',
					group: 'staff',
					after: 'roles_and_permissions',
					order: 30,
					component: () => import('@/pages/Admin/Settings/Contracts.vue'),
				},
				{
					id: 'datev',
					icon: 'fa-tags',
					group: 'staff',
					after: 'roles_and_permissions',
					order: 40,
					component: () => import('@/pages/Admin/Settings/Datev.vue'),
				},
				{
					id: 'user_dashboard',
					icon: 'fa-home',
					group: 'appearance',
					after: 'roles_and_permissions',
					order: 50,
					component: () => import('@/pages/Admin/Settings/UserDashboard.vue'),
				},
			],
		},
	},
	layout: {
		//context_header_slot: () => import('./layout/ContextHeaderSlot.vue'),
	},
});

import AppBroadcastPlugin from '@lib/plugins/broadcast';
app.use(AppBroadcastPlugin);

// Load additional handfy plugins
import Moment from '@lib/plugins/moment';
app.use(Moment);

// The sidebar is custom and is defined in the app
import Sidebar from '@/sidebar';
app.use(Sidebar);

// App Template Component for Notifications
import Notification from '@lib/plugins/layouts/notification';
app.use(Notification);

// The context works pretty much the same in all apps and is only customized in the app
import { AppApplicationPlugin } from '@lib/plugins/layouts/application';
app.use(AppApplicationPlugin);

// The context works pretty much the same in all apps and is only customized in the app
import { AppContextPlugin } from '@lib/plugins/layouts/context';
app.use(AppContextPlugin);

import Filters from '../../lib/js/filters';
app.use(Filters);

// Enable performance tracking
if (import.meta.env.DEV) {
	app.config.performance = true;
}

// Mount the app
app.mount('#app');
